import { GenIcon } from '../helpers/IconBase.es.js';

const FilterFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M19.75 3H3.75C3.33579 3 3 3.33579 3 3.75V6.03571L3.00994 6.15743C3.03623 6.3173 3.11385 6.46557 3.23276 6.57882L9.399 12.452L9.4 19.75C9.4 20.1642 9.73579 20.5 10.15 20.5H13.35L13.4518 20.4932C13.8178 20.4435 14.1 20.1297 14.1 19.75L14.099 12.453L20.2672 6.57882C20.4159 6.43726 20.5 6.24097 20.5 6.03571V3.75C20.5 3.33579 20.1642 3 19.75 3Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { FilterFilled };
